module.exports = __webpack_public_path__ + "img/icon (6).36c23474.png";